import * as React from "react";
import { Badge as MantineBadge } from "@mantine/core";
import styled, { css, useTheme } from "styled-components";
import sizeForMantine from "theme/utils/sizeForMantine";
const mapStyle = (style, theme) => style === "default" ? theme.colors.button.gray.background : theme.colors.variant[style];
const mapFontSize = {
  xs: "tiny",
  sm: "small",
  md: "small",
  lg: "body"
};
const StyledBadge = styled(MantineBadge)(
  ({ theme, color, size }) => css`
    text-transform: none;
    background-color: ${color};
    color: ${theme.utils.contrastingColor(color)};

    /* Let the badge shrink below its content width — as a flex/grid item (min-width: 0) and
       capped to its container (max-width: 100%) instead of Mantine's default width: fit-content.
       Without this the badge always stays as wide as its text, so the label below never gets a
       constrained width to truncate against. */
    min-width: 0;
    max-width: 100%;

    .mantine-Badge-label {
      font-size: ${theme.fonts.size[mapFontSize[size]]};
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &.uppercase {
      text-transform: uppercase;
    }
  `
);
const Badge = ({
  "aria-label": ariaLabel = void 0,
  bsStyle = "default",
  className = void 0,
  children = void 0,
  "data-testid": dataTestid,
  onClick = void 0,
  onMouseEnter = void 0,
  onMouseLeave = void 0,
  role = void 0,
  style = void 0,
  title = void 0,
  bsSize = "md",
  uppercase = false
}, ref) => {
  const theme = useTheme();
  const color = mapStyle(bsStyle, theme);
  const size = sizeForMantine(bsSize);
  const sharedProps = {
    "aria-label": ariaLabel,
    color,
    className: uppercase ? `${className != null ? className : ""} uppercase` : className,
    title,
    "data-testid": dataTestid,
    role,
    style,
    variant: "filled",
    onMouseEnter,
    onMouseLeave,
    size
  };
  if (onClick) {
    return /* @__PURE__ */ React.createElement(
      StyledBadge,
      {
        ...sharedProps,
        style: { cursor: "pointer", ...style },
        component: "button",
        ref,
        onClick
      },
      children
    );
  }
  return /* @__PURE__ */ React.createElement(StyledBadge, { ...sharedProps, component: "span", ref }, children);
};
export default React.forwardRef(Badge);
